import { CONTRACT_SEARCH } from '@Constants/types';
import { ContractsStatus, DocumentStatus } from '@Constants/status';

const initialState = {
    searchResultsLoadedState: ContractsStatus.NOT_LOADED,
    searchResults: [],
    totalSearchResults: 0,
    currentSearchPageOffset: 0,
    searchResultsPageSize: 20,
    searchingInProgress: false,
    moreAvailable: false,
    selectedContractLoadedState: ContractsStatus.NOT_LOADED,
    exportedDocxExists: false,
    permaLinkOriginal: '',
    permaLinkDOCX: '',
    exportedDocxDownloadPath: '',
    originalDocxDownloadPath: '',
    contractingParties: [],
    uploadedByUsername: '',
    selectedDocumentId: '',
    selectedFilename: '',
    selectedDocImportedAt: '',
    selectedDocUploadedByUrl: '',
    generationJobId: '',
    generationError: '',
    documentStatus: DocumentStatus.NOT_SUBMITTED,
    lastSearchQuery: '',
    lastUploadedByMe: true,
    lastHistory: false,
    lastSearchType: ''
};

export default function contractsReducer(state = initialState, action) {
    let newPageOffset = state.currentSearchPageOffset;
    let newMoreAvailable = false;

    switch (action.type) {
        case CONTRACT_SEARCH.SEARCH_REQUESTED:
            return {
                ...state,
                searchingInProgress: true
            };

        case CONTRACT_SEARCH.SEARCH_SUCCESS:
            if (
                state.currentSearchPageOffset + state.searchResultsPageSize <
                action.payload.totalCount
            ) {
                newMoreAvailable = true;
            }

            if (action.payload.totalCount < state.searchResultsPageSize) {
                newMoreAvailable = false;
            }

            return {
                ...state,
                searchResults: [...state.searchResults, ...action.payload.data.items],
                totalSearchResults: action.payload.totalCount,
                searchResultsLoadedState: ContractsStatus.LOADED,
                searchingInProgress: false,
                moreAvailable: newMoreAvailable
            };
        case CONTRACT_SEARCH.SEARCH_FAILURE:
            return {
                ...state,
                searchResults: [],
                searchResultsLoadedState: ContractsStatus.FAILED,
                searchingInProgress: false
            };
        // case CONTRACT_SEARCH.NO_PERMISSIONS:
        //     return {
        //         ...state,
        //         searchResults: [],
        //         searchResultsLoadedState: ContractsStatus.NO_PERMISSIONS
        //     };
        // case CONTRACT_SEARCH.TOKEN_EXPIRED:
        //     return {
        //         ...state,
        //         searchResults: [],
        //         searchResultsLoadedState: ContractsStatus.TOKEN_EXPIRED
        //     };
        case CONTRACT_SEARCH.SEARCH_CLEAR:
            return {
                ...state,
                searchResults: [],
                currentSearchPageOffset: 0,
                totalSearchResults: 0,
                searchResultsLoadedState: ContractsStatus.NOT_LOADED,
                searchingInProgress: false,
                lastHistory: false
            };
        // case CONTRACT_SEARCH.SEARCH_PREV_PAGE:
        //     if (state.currentSearchPageOffset - state.searchResultsPageSize >= 0) {
        //         newPageOffset = state.currentSearchPageOffset - state.searchResultsPageSize;
        //     }

        //     if (newPageOffset < 0) {
        //         newPageOffset = 0;
        //     }

        //     if (newPageOffset + state.searchResultsPageSize < state.totalSearchResults) {
        //         newMoreAvailable = true;
        //     }

        //     if (state.totalSearchResults < state.searchResultsPageSize) {
        //         newMoreAvailable = false;
        //     }

        //     return {
        //         ...state,
        //         currentSearchPageOffset: newPageOffset,
        //         moreAvailable: newMoreAvailable
        //     };
        case CONTRACT_SEARCH.SEARCH_NEXT_PAGE:
            if (
                state.currentSearchPageOffset + state.searchResultsPageSize <
                state.totalSearchResults
            ) {
                newPageOffset = state.currentSearchPageOffset + state.searchResultsPageSize;
            }

            if (newPageOffset + state.searchResultsPageSize < state.totalSearchResults) {
                newMoreAvailable = true;
            }

            if (state.totalSearchResults < state.searchResultsPageSize) {
                newMoreAvailable = false;
            }

            return {
                ...state,
                currentSearchPageOffset: newPageOffset,
                moreAvailable: newMoreAvailable
            };
        case CONTRACT_SEARCH.EXPORTED_DOCX_SUCCESS:
            return {
                ...state,
                exportedDocxExists: action.payload,
                selectedContractLoadedState: ContractsStatus.LOADED
            };
        case CONTRACT_SEARCH.EXPORTED_DOCX_FAILED:
            return {
                ...state,
                exportedDocxExists: false
            };

        case CONTRACT_SEARCH.GENERATE_PERMA_LINK_SUCCESS:
            if (action.payload.type === 'original') {
                // permaLinkOriginal
                return {
                    ...state,
                    permaLinkOriginal: action.payload.permaLink
                };
            }

            // permaLinkDOCX
            return {
                ...state,
                permaLinkDOCX: action.payload.permaLink
            };
        case CONTRACT_SEARCH.GENERATE_PERMA_LINK_FAILED:
            return {
                ...state,
                permaLinkOriginal: '',
                permaLinkDOCX: ''
            };
        case CONTRACT_SEARCH.GET_DOCX_DOWNLOAD_PATH_SUCCESS:
            return {
                ...state,
                exportedDocxDownloadPath: action.payload.exportedDocx,
                originalDocxDownloadPath: action.payload.originalDocx
            };
        case CONTRACT_SEARCH.GET_DOCX_DOWNLOAD_PATH_FAILED:
            return {
                ...state,
                exportedDocxDownloadPath: '',
                originalDocxDownloadPath: ''
            };

        case CONTRACT_SEARCH.FETCH_CONTRACTS_PARTIES_SUCCESS:
            return {
                ...state,
                contractingParties: action.payload
            };
        case CONTRACT_SEARCH.FETCH_CONTRACTS_PARTIES_FAILED:
            return {
                ...state,
                contractingParties: []
            };
        case CONTRACT_SEARCH.UPLOADED_BY_USER_SUCCESS:
            return {
                ...state,
                uploadedByUsername: action.payload
            };
        case CONTRACT_SEARCH.UPLOADED_BY_USER_FAILED:
            return {
                ...state,
                uploadedByUsername: '',
                selectedContractLoadedState: ContractsStatus.LOADED
            };
        case CONTRACT_SEARCH.SELECT_CONTRACT:
            return {
                ...state,
                selectedDocumentId: action.payload.id,
                selectedFilename: action.payload.filename,
                selectedDocImportedAt: action.payload.importedAt,
                selectedDocUploadedByUrl: action.payload.uploadedByUrl
            };
        case CONTRACT_SEARCH.CLEAR_SELECTED_CONTRACT:
            return {
                ...state,
                uploadedByUsername: '',
                contractingParties: [],
                permaLinkOriginal: '',
                permaLinkDOCX: '',
                exportedDocxDownloadPath: '',
                originalDocxDownloadPath: '',
                exportedDocxExists: false,
                selectedContractLoadedState: ContractsStatus.NOT_LOADED,
                selectedDocumentId: '',
                selectedFilename: '',
                selectedDocImportedAt: '',
                selectedDocUploadedByUrl: ''
            };
        // case CONTRACT_SEARCH.FETCH_SELECTED_CONTRACT_REQUESTED:
        //     return {
        //         ...state,
        //         selectedContractLoadedState: ContractsStatus.LOADING
        //     };
        case CONTRACT_SEARCH.EXPORTED_DOCX_GENERATION_REQUESTED:
            return {
                ...state,
                generationJobId: action.payload,
                generationError: '',
                documentStatus: DocumentStatus.PENDING
            };
        case CONTRACT_SEARCH.EXPORTED_DOCX_GENERATION_SUCCESS:
            return {
                ...state,
                generationJobId: '',
                generationError: '',
                documentStatus: DocumentStatus.PROCESSED
            };
        case CONTRACT_SEARCH.EXPORTED_DOCX_GENERATION_ERROR:
            return {
                ...state,
                generationJobId: '',
                generationError: action.payload,
                documentStatus: DocumentStatus.FAILED
            };
        case CONTRACT_SEARCH.EXPORTED_DOCX_GENERATION_RESET:
            return {
                ...state,
                generationJobId: '',
                generationError: '',
                documentStatus: DocumentStatus.NOT_SUBMITTED,
                exportedDocxExists: false,
                selectedContractLoadedState: ContractsStatus.NOT_LOADED
            };
        case CONTRACT_SEARCH.SEARCH_CRITERIA:
            return {
                ...state,
                lastSearchQuery: action.payload.lastSearchQuery,
                lastUploadedByMe: action.payload.lastUploadedByMe,
                lastHistory: true,
                lastSearchType: action.payload.lastSearchType
            };

        default:
            return state;
    }
}
